// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__UzRQd","content":"MainLayout_content__7fz-U","footer":"MainLayout_footer__RjHTD"};